import './scss/index.scss';

import { dcFactory } from '@deleteagency/dc';
import SearchComponent from 'components/search-page/js/search.component';

dcFactory.register(SearchComponent);
